(function () {
  'use strict';

  console.log('Sticky ATC: script loaded');

  function initStickyATC() {

    const sticky = document.querySelector('[data-sticky-add-to-cart]');

    if (!sticky) {
      console.log('Sticky ATC: sticky container not found');
      return;
    }

    /*
     * Trade theme product form
     */
    const productForm =
      document.querySelector('product-form form[data-type="add-to-cart-form"]') ||
      document.querySelector('form[action*="/cart/add"]');

    if (!productForm) {
      console.log('Sticky ATC: product form not found');
      return;
    }

    const originalButton =
      productForm.querySelector('button[name="add"].product-form__submit') ||
      productForm.querySelector('button[name="add"]');

    if (!originalButton) {
      console.log('Sticky ATC: Add to Cart button not found');
      return;
    }

    console.log(
      'Sticky ATC: original Add to Cart button found',
      originalButton
    );

    const stickyButton =
      sticky.querySelector('[data-sticky-atc-button]');

    if (!stickyButton) {
      console.log('Sticky ATC: sticky button not found');
      return;
    }

    /*
     * Show / hide sticky bar
     */
    function updateStickyVisibility() {

      const rect = originalButton.getBoundingClientRect();

      /*
       * When original Add to Cart is outside viewport,
       * show sticky button.
       */
      if (rect.bottom < 0 || rect.top > window.innerHeight) {
        sticky.classList.add('is-visible');
      } else {
        sticky.classList.remove('is-visible');
      }
    }

    /*
     * Sticky button clicks the REAL Shopify Add to Cart button.
     *
     * This is important because Shopify's product-form.js
     * continues handling cart AJAX, variants, errors, etc.
     */
    stickyButton.addEventListener('click', function () {

      if (originalButton.disabled) {
        return;
      }

      console.log('Sticky ATC: clicking original Add to Cart');

      originalButton.click();

    });

    /*
     * Listen to scroll
     */
    let ticking = false;

    window.addEventListener(
      'scroll',
      function () {

        if (!ticking) {

          window.requestAnimationFrame(function () {

            updateStickyVisibility();

            ticking = false;

          });

          ticking = true;
        }

      },
      { passive: true }
    );

    window.addEventListener(
      'resize',
      updateStickyVisibility
    );

    /*
     * Initial state
     */
    updateStickyVisibility();

    /*
     * Variant changes can replace/update the form/button.
     * Re-run periodically to keep the reference fresh.
     */
    const observer = new MutationObserver(function () {

      const currentButton =
        document.querySelector(
          'product-form form[data-type="add-to-cart-form"] button[name="add"]'
        );

      if (
        currentButton &&
        currentButton !== originalButton
      ) {

        console.log(
          'Sticky ATC: Shopify replaced Add to Cart button'
        );

        /*
         * We cannot reassign const.
         * Reload the initializer instead.
         */
        location.reload();

      }

    });

    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );

  }


  /*
   * Trade loads product-form.js asynchronously,
   * so give Shopify a little time.
   */
  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      function () {
        setTimeout(initStickyATC, 500);
      }
    );

  } else {

    setTimeout(initStickyATC, 500);

  }

})();